import { useMemo } from 'react';

import { PeriodTypeSVC } from '../types';

import { GridInitialStatePro } from '@mui/x-data-grid-pro/models/gridStatePro';

export const useGetFilterInitialState = (): GridInitialStatePro => {
  return useMemo(() => {
    return {
      filter: {
        filterModel: {
          items: [
            {
              columnField: 'periodTypeSvc',
              operatorValue: 'is',
              value: PeriodTypeSVC.m as PeriodTypeSVC
            }
          ]
        }
      }
    };
  }, []);
};
